.monitorFrame {
  position: relative;
  max-width: 700px;
  filter: drop-shadow(0 20px 18px rgba(0, 0, 0, 0.3)) drop-shadow(0 8px 6px rgba(0, 0, 0, 0.2));

  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    bottom: -25px;
    left: 50%;
    width: 70%;
    height: 35px;
    transform: translateX(-50%);
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.35);
    filter: blur(16px);
  }
}

.body {
  position: relative;
  padding: 13px 13px 20px;
  border-radius: 14px;
  background: linear-gradient(135deg, #e6e6e6 0%, #c2c2c2 15%, #9a9a9a 45%, #b0b0b0 75%, #dcdcdc 100%);
  border: 1px solid #8c8c8c;
  box-shadow:
    inset 0 1px 1px rgba(255, 255, 255, 0.6),
    inset 0 -2px 5px rgba(0, 0, 0, 0.3),
    inset 2px 0 4px rgba(255, 255, 255, 0.15);

  &::before {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 10px;
    pointer-events: none;
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.15);
  }
}

.bezel {
  position: relative;
  padding: 6px;
  border-radius: 7px;
  background: linear-gradient(145deg, #3d3d3d, #1a1a1a 45%, #454545);
  box-shadow:
    inset 0 2px 5px rgba(255, 255, 255, 0.04),
    inset 0 -3px 7px rgba(0, 0, 0, 0.95),
    0 2px 5px rgba(0, 0, 0, 0.8);

  &::before {
    content: '';
    position: absolute;
    inset: 1px;
    border-radius: 6px;
    pointer-events: none;
    border: 1px solid rgba(255, 255, 255, 0.07);
  }
}

.screen {
  position: relative;
  overflow: hidden;
  background: #000;
  border-radius: 3px;
  box-shadow:
    inset 0 0 30px rgba(0, 0, 0, 0.9),
    0 0 2px #000;

  &::after {
    content: '';
    position: absolute;
    z-index: 6;
    inset: 0;
    pointer-events: none;
    box-shadow:
      inset 0 0 18px rgba(0, 0, 0, 0.7),
      inset 0 0 2px rgba(255, 255, 255, 0.25);
  }
}

.logo {
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(0, 0, 0, 0.45);
  font-size: 10px;
  letter-spacing: 3px;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.powerLed {
  position: absolute;
  right: 16px;
  bottom: 6px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #69c9ff;
  box-shadow:
    0 0 3px #69c9ff,
    0 0 8px rgba(80, 190, 255, 0.75),
    0 0 15px rgba(80, 190, 255, 0.25);
}

@media (max-width: 767.98px) {
  .body {
    padding: 8px 8px 14px;
    border-radius: 10px;
  }

  .bezel {
    padding: 4px;
  }

  .logo {
    font-size: 7px;
  }
}
